/*
 * A change the home has reported that the pharmacy has not put on the chart yet, shown where the
 * carer is about to give the medicine. It does not stop anyone recording: it makes sure they know,
 * so the home's own policy — ask the nurse, record it as not given — can do the rest.
 */
import type { ReportedChange } from './api.ts';

export function ReportedWarning({ report, inBlister = false }: { report: ReportedChange; inBlister?: boolean }) {
  const at = new Date(report.reportedAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const day = new Date(report.reportedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  const today = new Date().toDateString() === new Date(report.reportedAt).toDateString();
  return (
    <div className="reported" role="note">
      <strong>
        Change reported {today ? at : `${day}, ${at}`}: {report.whatLabel.toLowerCase()}
        {inBlister ? ` — ${report.medicineName}` : ''}.
      </strong>{' '}
      "{report.detail}"
      <span className="small"> {report.reportedBy}{report.sourceDetail ? `, from ${report.sourceDetail}` : ''}.</span>{' '}
      <span className="small">
        Waiting for the pharmacy to update the chart.
        {inBlister ? ' It is in this blister.' : ''}
      </span>
    </div>
  );
}
